import '/src/styles/style.css';


import {getCenter as getExtentCenter, getWidth as getExtentWidth, getHeight as getExtentHeight} from 'ol/extent';
import Style from 'ol/style/Style';

import loadJSON from '/src/modules/init/loadData';
import {setBrowserService, createBaseMap, showFeatureByParameter} from '/src/modules/init/base';
import createLayer from '/src/modules/init/layer';
import {setHeight} from '/src/modules/misc/misc';
import {focusOn} from '/src/modules/features/featureControl';
import {generate404} from '/src/modules/error/error';
import {createNavigationEntries} from '/src/modules/Controls/sideNavigation/sideNavigation';
import {addNavigatorOptions, closeSideNavigation, prettyNavigator, selectCenterFeature} from '/src/modules/Controls/navigator/navigator';
import {showContext, terminateContext} from '/src/modules/Controls/context/context';
import displayFeatureInfo from '/src/modules/tooltip/tooltip';
import {alternativeStaendeStyle} from '/src/modules/features/featureStyle';
import {replaceTextPlaceholder} from '/src/modules/language/language';
import {BrowserService} from '/src/services/BrowserService';
import { loadConfig } from './src/features/config/config';

import 'simplebar/dist/simplebar.css';
import 'simplebar/dist/simplebar';
import { bootstrap } from './src/app/bootstrap';
import VectorLayer from 'ol/layer/Vector';
import { createCenteredTextLayer } from './src/modules/features/featureStyle';

setBrowserService(new BrowserService());

export let map;
export let baseConfig;
export let exhibitionConfig;
export let deviceOrientation = screen['msOrientation'] || (screen['orientation'] || screen['mozOrientation'] || {}).type;
export let baseRotation = 0;
export let fileKey = '';

const bootstrapResult = await bootstrap();

export let messeId = bootstrapResult.extFairId;
export let getQlId = bootstrapResult.quotelineId;
export let getaQlId = bootstrapResult.aQuotelineId;
export let lang = bootstrapResult.lang;
export let showHall = bootstrapResult.showHall;
export let showOnlyNischenstaende = bootstrapResult.showOnlyNischenstaende === true || bootstrapResult.showOnlyNischenstaende === 'true';

/**
 * Listen to changes to the device orientation
 */
window.addEventListener('orientationchange', () => {
  deviceOrientation = screen['msOrientation'] || (screen['orientation'] || screen['mozOrientation'] || {}).type;
}, {passive: true});

/**
 * Initialize variables
 */
let navigatorOptions = [];

/**
 * The initial async function loading all necessary OL parts
 */
const init = async () => {
  /**
   * Check if there's the parameter 'aqlid' for alternative QuoteLineId
   * @type {string}
   */
  // getaQlId = findGetParameter('aqlid');

  /**
   * Load exhibition specific configuration. If an error occurs, throw new Error for 404 page
   */
  try {
    exhibitionConfig = await loadJSON('system/loadjson.php?type=config&mid=' + messeId);
  } catch (e) {
    throw new Error('Fair configuration not found');
  }

  if (exhibitionConfig !== undefined) {
    typeof exhibitionConfig['core']['title_' + lang['id']] !== 'undefined' ? document.title = exhibitionConfig['core']['title_' + lang['id']] : null;
    typeof exhibitionConfig['core']['description_' + lang['id']] !== 'undefined' ? document.querySelector('meta[name="description"]').setAttribute('content', exhibitionConfig['core']['description_' + lang['id']]) : null;

    /**
     * Check if there's the parameter 'qlid' for QuoteLineId
     * @type {string}
     */
    // getQlId = findGetParameter('qlid');
    let baseLayer;
    let halleArray = [];
    let boothLayer;
    let boothFiles = [];

    if (!getQlId || getQlId.trim() === '') {
      if (showHall && showHall.trim() !== '') {
        map = await createBaseMap(baseConfig, exhibitionConfig);

        try {
          let folder = '';

          if (typeof exhibitionConfig['core']['fairground'] !== 'undefined' && (exhibitionConfig['core']['fairground'] != '' || exhibitionConfig['core']['fairground'] !== null)) {
            folder = exhibitionConfig['core']['fairground'];
          } else {
            folder = baseConfig['core']['fairground'];
          }

          // let url = 'system/loadjson.php?type=list&folder=' + folder + '&mid=' + messeId + '&hall=' + showHall;
          baseLayer = {files: [`assets/layers/${folder}/${showHall}.json`]};

          boothLayer = await loadJSON(`system/loadjson.php?type=boothByHall&mid=${messeId}&hall=${showHall}`);
        } catch (e) {
          throw new Error(e);
        }

        if (typeof boothLayer['error'] === 'undefined' && typeof boothLayer['files'] !== 'undefined') {
          for (let boothFile of boothLayer['files']) {
            if (boothFile !== 'undefined') {
              let boothFileWithoutPath = boothFile.split('\\').pop().split('/').pop();
              let layerFileName = boothFileWithoutPath.substring(boothFileWithoutPath.indexOf('.') + 1);

              let regex = new RegExp('\\.\\.\\/assets\\/exhibitions\\/' + messeId + '\\/layers\\/staende\\/[0-9]*\\.');
              let label = boothFile.split(regex).pop().split('.json').shift();
              let regex2 = new RegExp('^([a-zA-Z\u00C0-\u017F]+) ?([a-zA-Z0-9\-]+) ?([a-zA-Z]*)');
              let split = label.split(regex2);

              let id = "";

              // TODO Überarbeiten oder ggf. ganz entfernen
              if (split[1] === "Halle") {
                id = "";
                id += split[2];
                id += split[4] !== '' ? split[4] : '';
              } else if (split[1] === lang['OUTDOORSPACE'] || split[1] === 'Freigelände') {
                id = "FGL";
                id += split[2];
                id += split[4] !== '' ? split[4] : '';
              } else if (split[1] === "ICM") {
                id = "ICM";
                id += split[3] !== '' ? split[3] : '';
              } else if (split[1] === "Eingang") {
                id = "E" + split[2].charAt(0);
                id += split[3] !== '' ? split[3].charAt(0) : '';
              } else if (split[1] === 'Atrium' || split[1] === 'Atriu') {
                id = "ATR"
              } else {
                id = split[1].charAt(0);
                id += split[2];
                id += split[4] !== '' ? split[4] : '';
              }

              let file = {
                'id': id.toUpperCase(),
                'label': split[1] + ' ' + split[2],
                'file': boothFile,
              };

              boothFiles.push(file);
            }
          }
        } else {
          throw new Error(lang['errorNoBoothForBoothId']);
        }

        fileKey = boothFiles[0]?.id ?? '';
      }
    } else if (getQlId !== undefined && getQlId !== '') {
      /**
       * Create map with base configuration
       */
      map = await createBaseMap(baseConfig, exhibitionConfig);

      /**
       * Get list with all booth layers
       */
      try {
        if (getQlId !== undefined && getQlId !== '') {
          if (getaQlId !== undefined && getaQlId !== '') {
            boothLayer = await loadJSON('system/loadjson.php?type=booth&mid=' + messeId + '&qlid=' + getQlId + '&aqlid=' + getaQlId);
          } else {
            boothLayer = await loadJSON('system/loadjson.php?type=booth&mid=' + messeId + '&qlid=' + getQlId);
          }
        } else {
          throw new Error(lang['errorNoBoothId']);
        }
      } catch (e) {
        throw new Error('No booth found');
      }

      if (typeof boothLayer['error'] === 'undefined' && typeof boothLayer['files'] !== 'undefined') {
        for (let boothFile of boothLayer['files']) {
          if (boothFile !== 'undefined') {
            let boothFileWithoutPath = boothFile.split('\\').pop().split('/').pop();
            let layerFileName = boothFileWithoutPath.substring(boothFileWithoutPath.indexOf('.') + 1);

            let regex = new RegExp('\\.\\.\\/assets\\/exhibitions\\/' + messeId + '\\/layers\\/staende\\/[0-9]*\\.');
            let label = boothFile.split(regex).pop().split('.json').shift();
            let regex2 = new RegExp('^([a-zA-Z\u00C0-\u017F]+) ?([a-zA-Z0-9\-]+) ?([a-zA-Z]*)');
            let split = label.split(regex2);

            let id = "";

            // TODO Überarbeiten oder ggf. ganz entfernen
            if (split[1] === "Halle") {
              id = "";
              id += split[2];
              id += split[4] !== '' ? split[4] : '';
            } else if (split[1] === lang['OUTDOORSPACE'] || split[1] === 'Freigelände') {
              id = "FGL";
              id += split[2];
              id += split[4] !== '' ? split[4] : '';
            } else if (split[1] === "ICM") {
              id = "ICM";
              id += split[3] !== '' ? split[3] : '';
            } else if (split[1] === "Eingang") {
              id = "E" + split[2].charAt(0);
              id += split[3] !== '' ? split[3].charAt(0) : '';
            } else if (split[1] === 'Atrium' || split[1] === 'Atriu') {
              id = "ATR"
            } else {
              id = split[1].charAt(0);
              id += split[2];
              id += split[4] !== '' ? split[4] : '';
            }

            let file = {
              'id': id.toUpperCase(),
              'label': split[1] + ' ' + split[2],
              'file': boothFile,
            };

            halleArray.push(layerFileName);
            boothFiles.push(file);
          }
        }
      } else {
        throw new Error(lang['errorNoBoothForBoothId']);
      }

      fileKey = boothFiles[0]?.id ?? '';

      if (halleArray.length > 0) {
        let folder = '';

        if (typeof exhibitionConfig['core']['fairground'] !== 'undefined' && (exhibitionConfig['core']['fairground'] != '' || exhibitionConfig['core']['fairground'] !== null)) {
          folder = exhibitionConfig['core']['fairground'];
        } else {
          folder = baseConfig['core']['fairground'];
        }

        let url = 'system/loadjson.php?type=list&folder=' + folder + '&mid=' + messeId + '&hall=';
        if (halleArray.length > 1) {
          for (let halle of halleArray) {
            url += encodeURI(halle + ',');
          }
        } else {
          url += encodeURI(halleArray[0]);
        }

        try {
          baseLayer = await loadJSON(url);
        } catch (e) {
          throw new Error('No base layer found');
        }
      } else {
        try {
          baseLayer = await loadJSON('system/loadjson.php?type=list&mid=' + messeId);
        } catch (e) {
          throw new Error('No base layer found');
        }
      }
    } else {
      throw new Error(lang['errorNoBoothId']);
    }

    /**
     * Create all base layers
     */

    let mapLayer;

    for (let baseLayerFile of baseLayer['files']) {
      mapLayer = await createLayer(baseLayerFile);
      mapLayer.getSource().getFeatures().forEach((feature) => {
        if (
          feature.get('type') === 'Halle'
          || feature.get('type') === 'Hof'
          || feature.get('type') === 'Eingang'
          || feature.get('type') === 'Freigelände'
          || feature.get('type') === 'Atrium'
          || feature.get('type') === 'ICM'
        ) {
          if (typeof feature.get('rotationValue') !== 'undefined' && feature.get('rotationValue') !== '') {
            baseRotation = feature.get('rotationValue') * (Math.PI / 180);
            map.getView().setRotation(feature.get('rotationValue') * (Math.PI / 180));
          }
          if (typeof feature.get('clickable') !== 'undefined' && feature.get('clickable') === true) {
            /**
             * Check if feature (either of type Halle, Eingang or Freigelaende) has a context and add a new entry to the feature
             */
            let contextConfiguration = exhibitionConfig['context'][feature.getId()];

            if (typeof contextConfiguration !== 'undefined' && contextConfiguration['display'] === true) {
              let featureName = feature.get('name');

              featureName = replaceTextPlaceholder(featureName);

              let contextName = '';

              if (feature.get('type') === 'Halle') {
                contextName = lang['jsonHall'] + ' ' + featureName;
              } else if (feature.get('type') === 'Eingang') {
                contextName = lang['jsonEntry'] + ' ' + featureName;
              } else if (feature.get('type') === 'Hof') {
                contextName = lang['YARD'] + ' ' + featureName;
              } else {
                contextName = featureName;
              }

              let contextObject = {
                'icon': contextConfiguration['icon'],
                // 'name': feature.get('type') !== 'Freigelände' ? (feature.get('type') === 'Halle' ? lang['jsonHall'] + ' ' + featureName : (feature.get('type') === 'Eingang' ? lang['jsonEntry'] + ' ' + featureName : featureName)) : featureName,
                'name': contextName,
                'images': contextConfiguration['images'],
                'videos': contextConfiguration['videos'],
                'entries': contextConfiguration['entries'],
                'sponsor': contextConfiguration['sponsor'],
              };
              feature.set('contextObject', contextObject);
            }
          }
        }
      });

      /**
       * Then check if there's a switch element in the context object and if it is set to false (means, the corresponding features should be invisible)
       * If features are found, give them an empty style to make them invisible
       */
      mapLayer.getSource().getFeatures().forEach((feature) => {
        if (typeof feature.get('contextObject') !== 'undefined') {
          for (let contextEntry of feature.get('contextObject')['entries']) {
            if (contextEntry['type'] === 'switch' && contextEntry['switchable'] === true && contextEntry['switched'] === false) {
              mapLayer.getSource().getFeatures().forEach((layerFeature) => {
                if (typeof layerFeature.get('identifier') !== 'undefined' && layerFeature.get('identifier') === (contextEntry['identifier'] + mapLayer.get('name'))) {
                  layerFeature.setStyle(new Style());
                }
              });
            }
          }
        }
      });

      map.addLayer(mapLayer);

      if (typeof mapLayer.get('navigator') !== 'undefined' && mapLayer.get('navigator') === true) {
        navigatorOptions.push(mapLayer);
      }
    }

    // addLegendEntry(exhibitionConfig.legend);
    addNavigatorOptions(navigatorOptions);
    if (typeof exhibitionConfig['menu']['display'] !== 'undefined' && exhibitionConfig['menu']['display'] !== false) {
      if (typeof exhibitionConfig['menu']['entries'] !== 'undefined' && exhibitionConfig['menu']['entries'].length > 0) {
        createNavigationEntries(exhibitionConfig['menu']['entries']);
      } else {
        console.log('Es wurden keine Menüeinträge gefunden');
      }
    }

    /**
     * Create a new layer for each booth file
     */
    for (let boothLayerFile of boothFiles) {
      let mapLayer = await createLayer(boothLayerFile.file, showOnlyNischenstaende);
      mapLayer.getSource().getFeatures().forEach((feature) => {
        feature.set('correspondingId', boothLayerFile.id);
        feature.set('label', boothLayerFile.label);
      });
      map.addLayer(mapLayer);
    }

  } else {
    throw new Error(lang['errorNoValidConfiguration']);
  }
};

try {
  /**
   * Load base
   */
  baseConfig = await loadConfig('base');

  if (messeId !== null) {
    let idFound = false;
    /**
     * Check if there's an internal id for the given external exhibition id
     */
    const idConnections = baseConfig?.idConnection;

    if (Array.isArray(idConnections) && idConnections.every(item => item && typeof item === "object")) {
      if (idConnections.length > 0) {
        for (let idConnection of idConnections) {
          if (!idFound) {
            if (idConnection?.externalId === messeId) {
              messeId = idConnection.internalId;
              idFound = true;
              break;
            }
          }
        }

        if (!idFound) throw new Error(lang['errorGivenExhibitionIdNotFound']);
      } else {
        throw new Error(lang['errorNoExhibitionIdsInConfig']);
      }
    }
    /**
     * Initialize the map and make everything pretty
     */
    init().then(() => {
      /**
       * If GET parameter "qlid" is given, show the booth
       */
      if (getQlId !== null && getQlId.trim() !== '') {
        showFeatureByParameter(getQlId);
      } else if (showHall !== null && showHall.trim() !== '') {
        const layers = map.getLayers();

        let featureExtent = null;
        let extentCenter = null;
        let hallSoldOut = true;

        layers.forEach(function (layer) {
          if (layer instanceof VectorLayer) {
            layer.getSource().forEachFeature((feature) => {
              if (feature.getId() === showHall) {
                featureExtent = feature.getGeometry().getExtent();
                extentCenter = getExtentCenter(featureExtent);

                focusOn(
                  extentCenter,
                  feature.get('rotation'),
                  feature.get('zoom'),
                  featureExtent,
                  false
                );

                if (typeof feature.get('contextObject') !== 'undefined') {
                  showContext(feature);
                }
              }
            });
          }

          if (layer.get('title') == "Stände") {
            layer.getSource().forEachFeature((feature) => {
              const isNischenstand = feature.get('isNischenstand') ?? false;
              const isSold = feature.get('isSold') ?? false;

              if (isNischenstand && !isSold) {
                hallSoldOut = false;
              }
            })
          }
        });

        if (hallSoldOut && showOnlyNischenstaende) {
          const soldOutText = createCenteredTextLayer(extentCenter, lang['HALLSOLDOUT']);
          map.addLayer(soldOutText);
        }
      }

      /**
       * If alternative qlid is given, show a button to switch to the alternative booth
       */
      if (getaQlId !== null && getaQlId.trim() !== '') {
        let featureExtent;
        let extentCenter;
        let rotate;
        map.getLayers().forEach((layer) => {
          if (typeof layer.getSource().forEachFeature === 'function') {
            layer.getSource().forEachFeature((feature) => {
              if (feature.get('type') === 'Stand') {
                if (feature.get('quotelineid') === getaQlId) {
                  feature.setStyle(alternativeStaendeStyle(feature, map.getView().getResolution()));

                  let alternativePlaceButton = document.createElement('div');
                  alternativePlaceButton.className = 'alternativePlaceButton';
                  alternativePlaceButton.id = 'alternativePlaceButton';
                  alternativePlaceButton.innerHTML = '<i class="fas fa-step-forward"></i> ' + lang['buttonAlternativePlacementProposal'] + ' <b>' + feature.get('number') + '</b>';

                  alternativePlaceButton.addEventListener('click', () => {
                    featureExtent = feature.getGeometry().getExtent();
                    extentCenter = getExtentCenter(featureExtent);
                    if (typeof exhibitionConfig['core']['rotateOnFocus'] !== 'undefined' && exhibitionConfig['core']['rotateOnFocus'] === false) {
                      rotate = false;
                    } else {
                      rotate = getExtentWidth(featureExtent) < getExtentHeight(featureExtent);
                    }

                    focusOn(extentCenter, rotate, 42, null, true);
                    showContext(feature);
                  }, {passive: true});

                  let buttonContainer = document.getElementById('buttonContainer');
                  let printButton = document.getElementById('printOffer');

                  buttonContainer.insertBefore(alternativePlaceButton, printButton);
                }
              }
            });
          }
        });
      }

      /**
       * Check if DOM is ready and call the prettyNavigator function to beautify the navigator jump list
       * This check is downward compatible to IE 8
       */
      if (document.readyState !== 'loading') {
        prettyNavigator();
      } else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', prettyNavigator);
      } else {
        document.attachEvent('onreadystatechange', () => {
          if (document.readyState !== 'loading') {
            prettyNavigator();
          }
        });
      }

      /**
       * Automatically resize the navigator jump list depending on the client height
       */
      window.addEventListener('resize', () => {
        document.getElementById('navigatorSelectOptions').style.maxHeight = setHeight(-100) + 'px';
      }, {passive: true});

      /**
       * Add a drag handler to prevent closing the side navigation and/or the context while dragging the map
       */
      map.addEventListener('dragend', (evt) => {
        evt.preventDefault();
      }, {passive: true});

      /**
       * Add a click event handler on the map for feature click
       */
      map.addEventListener('click', (evt) => {
        map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
          if (layer.get('title') !== 'Stände') {
            if (feature.get('clickable') === true) {
              let featureExtent = feature.getGeometry().getExtent();
              let extentCenter = getExtentCenter(featureExtent);

              let rotationValue = false;

              if (typeof feature.get('rotation') !== 'undefined' && feature.get('rotation') === true) {
                rotationValue = feature.get('rotationValue');
              }
              focusOn(extentCenter, feature.get('rotation'), feature.get('zoom'), featureExtent, true, rotationValue);
              /**
               * Check if feature is listed in Navigator (feature.getId() !== undefined).
               * If true, select corresponding entry in Navigator and make it active
               */
              if (feature.getId() !== undefined) {
                let selectBox = document.getElementById('navigatorSelectOptions');
                let selectOptions = selectBox.getElementsByClassName('navigatorSelectOption');

                for (let so = 0; so < selectOptions.length; so++) {
                  if (feature.getId() === selectOptions[so].getAttribute('data-value')) {
                    document.getElementById('navigatorSelectTriggerText').innerHTML = selectOptions[so].innerHTML;

                    for (let si = 0; si < selectOptions.length; si++) {
                      if (selectOptions[si].classList.contains('selection')) {
                        selectOptions[si].classList.remove('selection');
                      }
                    }
                    selectOptions[so].classList.add('selection');
                  }
                }
              }
            }
            if (typeof feature.get('contextObject') !== 'undefined') {
              showContext(feature);
            } else {
              terminateContext();
            }
          } else {
            if (feature.get('quotelineid') === getQlId || feature.get('quotelineid') === getaQlId) {
              showContext(feature);
            } else {
              terminateContext();
            }
          }
          return true;
        });
      }, {passive: true});

      /**
       * Add handler for navigator entry selection depending on feature in center of view
       * For mouse wheel
       */
      map.addEventListener('wheel', () => {
        if (map.getView().getResolution() < 0.9) {
          selectCenterFeature(true);
        } else {
          selectCenterFeature(false);
        }
      }, {passive: true});

      /**
       * For end of moving
       */
      map.addEventListener('moveend', () => {
        if (map.getView().getResolution() < 0.9) {
          selectCenterFeature(true);
        } else {
          selectCenterFeature(false);
        }
      }, {passive: true});

      /**
       * Add handler for showing tooltip
       */
      map.addEventListener('pointermove', (evt) => {
        if (evt.pointerType !== 'touch') {
          let info = document.getElementById('info');

          if (evt.dragging) {
            info.style.display = 'none';
          }
          let pixel = map.getEventPixel(evt.originalEvent);
          if (map.getView().getResolution() <= 0.4) {
            if (!showOnlyNischenstaende){
              displayFeatureInfo(pixel);
            }
          }
        }
      }, {passive: true});

      document.getElementById(baseConfig['mapProperties']['containerId']).addEventListener('mouseout', () => {
        let info = document.getElementById('info');

        info.style.display = 'none';
      }, {passive: true});

      /**
       * Add several click handlers for closing the navigation when it is opened
       */
      if (typeof exhibitionConfig['menu'] !== 'undefined' && exhibitionConfig['menu']['display'] !== false) {
        map.addEventListener('click', closeSideNavigation, {passive: true});

        document.querySelector('.navigatorContainer').addEventListener('click', (evt) => {
          if (evt.target['id'] !== 'navigatorButton' && evt.target['id'] !== 'buttonBars') {
            closeSideNavigation(evt);
          }
        }, {passive: true});

        if (document.getElementById('control-back-to-booth')) {
          document.getElementById('control-back-to-stand').addEventListener('click', closeSideNavigation, {passive: true});
        }

        document.getElementById('contextBox').addEventListener('click', closeSideNavigation, {passive: true});
      }

      /**
       * Add screenshot functionality
       */
      let screenshotButton = document.createElement('div');
      screenshotButton.className = 'screenshotButton';
      screenshotButton.id = 'screenshotButton';
      screenshotButton.innerHTML = '<i class="fas fa-camera"></i>';

      screenshotButton.addEventListener('click', () => {
        // printScreen(false);
        // printPdf(messeId, getQlId, 'HalleB1', null);
      }, {passive: true});
    }).catch((err) => {
      console.log(err);
      generate404('Flayr Fehler', err.message);
    });
  } else {
    throw new Error(lang['errorInitFailedNoValidExhibitionId']);
  }
} catch (error) {
  console.log(error);
  generate404(lang['errorTitle'], error.message);
}